import { Env } from "lib-klab-core";

import { envDocumentDev } from "./klab/document";
import { envKlabIamDev } from "./klab/iam";
import { envKlabMessagingDev } from "./klab/messaging";
import { envKlabNotificationsDev } from "./klab/notifications";
import { envOrganizationDev } from "./klab/organization";
import { envPeopleDev } from "./klab/people";
import { envReportDev } from "./klab/report";

import { envAgreementDev } from "./staff/agreement";
import { envEmployeeDev } from "./staff/employee";
import { envHrDev } from "./staff/hr";
import { envMasterDataDev } from "./staff/master-data";
import { envPayrollDev } from "./staff/payroll";
import { envStaffOrganizationDev } from "./staff/organization";
import { envAccountingDev } from "./staff/accounting";
import { envTreasuryDev } from "./staff/treasury";
import { envProcurementDev } from "./staff/procurement";
import { envRequirementDev } from "./staff/requirement";
import { envIntegrationDev } from "./staff/integration";
import { envAuditDev } from "./staff/audit";

export const environment: Env = {
    production: false,
    micros: {
        iam: envKlabIamDev,
        organization: envOrganizationDev,
        report: envReportDev,
        people: envPeopleDev,
        messaging: envKlabMessagingDev,
        document: envDocumentDev,
        notifications: envKlabNotificationsDev,
        staffOrganization: envStaffOrganizationDev,
        masterData: envMasterDataDev,
        employee: envEmployeeDev,
        hr: envHrDev,
        agreement: envAgreementDev,
        payroll: envPayrollDev,
        accounting: envAccountingDev,
        treasury: envTreasuryDev,
        procurement: envProcurementDev,
        requirement: envRequirementDev,
        integration: envIntegrationDev,
        audit: envAuditDev,
    },
};

// Live-view signaling WebSocket — direct to the liveview-signaling MS host.
// NOTE: the gateway route /ms-liveview is NOT yet active on the dev gateway
// (returns 404 — the api-gateway needs a restart/refresh to load the new
// route from config-server). Using the proven direct host meanwhile.
export const liveviewConfig = {
    wsUrl: 'wss://signaling-dev.klab.inclub.world/ws/v1/liveview',
};
